export default __webpack_public_path__ + "assets/images/a8cc9b0be7c0018ea942aa087e6ff7fd.jpg";